import React, { useEffect, useState, useMemo } from 'react';
import { Space, Table, Tag, Button, Image, Card, Input, Flex, Select, Modal, Form, Popconfirm } from 'antd';
import { useNavigate, useSearchParams } from "react-router";
import { DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { useForm, useWatch } from "antd/es/form/Form";
import UserService from 'services/collaborator_user';
import { useApp } from "contexts/app";
import { useAuth } from "contexts/auth";
import _ from "lodash"
import { formatCurrency } from "utils/number"
import { formatDate } from "utils/date"
const { Search } = Input;
const service = new UserService();


const permissions = [
    { label: "Quản lý sản phẩm", value: "product.all" },
    { label: "Quản lý đơn hàng", value: "order.all" },
    { label: "Quản lý khách hàng", value: "customer.all" },
    { label: "Quản lý công nợ", value: "debt.all" },
    { label: "Quản lý voucher", value: "voucher.all" },
    { label: "Cấu hình shop", value: "setting.all" },
]

const UserList = () => {
    let navigate = useNavigate();
    const [data, setData] = useState([]);
    const { showNotify, modal, showLoading, prompt } = useApp();
    const [filter, setFilter] = useState({})

    const [showAddUser, setShowAddUser] = useState(false);
    const [showUpdateUser, setShowUpdateUser] = useState(false);
    const [updateUser, setUpdateUser] = useState()

    const { user } = useAuth();

    const { message } = useApp();
    useEffect(() => {
        delaySearch(filter);


    }, [filter])

    const onSearch = async (data) => {
        var postData = { info: data?.info };
        var list = await service.list(postData);
        setData(list);
    }


    const delaySearch = useMemo(() => _.debounce(onSearch, 500, { leading: false }), []);


    const setFilterValue = (name, value) => {

        var newFilter = { ...filter };
        newFilter[name] = value;
        setFilter(newFilter)
    }

    const loadData = async () => {
        var list = await service.list();
        setData(list);
    }





    const editTag = (id) => {
        prompt({
            title: "Chỉnh sửa", label: "Nhập tên",
            onOk: async (text) => {

                showLoading(true);
                await service.update({ name: text, id: id });
                await loadData();
                showLoading(false)
            }
        });
    }

    const deleteUser = async id => {
        showLoading(true);
        try {
            await service.removeUser(id);
        } catch (error) {
            message.error("Không thể xoá")
        }

        await loadData();
        showLoading(false)
    }


    const clickUpdateUser = (user) => {
        setShowUpdateUser(true);
        setUpdateUser(user);
    }


    const columns = [
        {
            title: 'Tài khoản',
            render: (_, record) => {
                return (
                    <div>
                        <Space direction='vertical'>

                            <div>
                                {record.full_name}
                            </div>
                            <div>
                                {record.phone}
                            </div>
                        </Space>
                    </div>

                )
            }
        },



        {
            title: 'Số dư hoa hồng',
            render: (_, record) => {
                return (
                    <div>
                        <Space>
                            {formatCurrency(record.commission?.current_commission)}
                        </Space>
                    </div>

                )
            }
        },


        {
            title: 'Hoa hồng đang xử lý',
            render: (_, record) => {
                return (
                    <div>
                        <Space>
                            <div>
                                {formatCurrency(record.commission?.pending_commission)}

                            </div>
                        </Space>
                    </div>

                )
            }
        },









        {
            title: "",
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    {user.id != record.id &&
                        <>
                      
                         
                                <Button type='link'onClick={e => navigate("/collaborator/withdraw/"+record.id)} >Chi tiết</Button>
                    
                        </>
                    }


                </Space>
            ),
        },
    ];



    return (

        <Space direction="vertical" size={16} style={{ width: "100%" }}>
            <Card style={{ width: "100%" }}>

                <Space direction="vertical" size={8} style={{ width: "100%" }} >
                    <Search
                        placeholder="Tên hoặc mã"
                        onChange={e => setFilterValue("info", e.target.value)}
                        style={{
                            width: "100%",
                        }}
                        value={filter.info}
                    />

                    <Flex justify='flex-end' style={{ width: "100%" }}>
                    
                    </Flex>
                </Space>

            </Card>
            <Card>
                <Table columns={columns} dataSource={data} />
            </Card>
            <AddNewUser open={showAddUser} onClose={e => setShowAddUser(false)}></AddNewUser>
            <UpdateUser open={showUpdateUser} onClose={e => setShowUpdateUser(false)} user={updateUser} onSaved={loadData}> </UpdateUser>
        </Space>
    )
}


const AddNewUser = ({ open, onClose }) => {
    const [form] = useForm();
    const { showLoading, showNotify } = useApp();

    const onFinish = async () => {
        const data = { ...form.getFieldsValue(), role: "ctv", permissions: [] };
        debugger
        showLoading(true);
        await service.invite(data);
        showNotify("Đã gửi lời mời")
        showLoading(false)
        onClose();


    };
    return (

        <>

            <Modal open={open} title="Mời cộng tác viên" onClose={onClose} onCancel={onClose} onOk={e => form.submit()}>

                <Form layout="vertical" form={form} initialValues={{}} onFinish={() => onFinish()} >
                    <Form.Item
                        label="Số điện thoại"
                        name="phone"
                        rules={[
                            {
                                required: true,
                                pattern: /^[0-9]{10}$/,
                                message: "Số điện thoại không đúng định dạng",

                            },

                            {
                                validator: async (_, value) => {

                                    return new Promise(async (r, e) => {

                                        try {
                                            var user = await service.checkPhoneCanInvite(value);
                                            if (user) {
                                                form.setFieldValue("user_id", user.id)
                                                r();
                                            } else {
                                                form.setFieldValue("user_id", null)
                                                e(new Error('Số điện thoại này đã chưa được đăng ký'));
                                            }
                                            // var data = await signUpService.checkPhone(value);
                                            // if (data.error) {
                                            //     e(new Error('Số điện thoại này đã được đăng ký rồi'));
                                            //     return;
                                            // }


                                        } catch (error) {

                                            e(new Error('Không thể kiểm tra số điện thoại'));
                                        }

                                    })




                                },
                            }

                        ]}
                    >
                        <Input placeholder="Phone"></Input>
                    </Form.Item>
                    <Form.Item

                        hidden
                        name="user_id"

                    >
                        <Input placeholder="Phone"></Input>
                    </Form.Item>




                </Form>

            </Modal>
        </>
    )



}



const UpdateUser = ({ open, onClose, user, onSaved }) => {
    const [form] = useForm();
    const { showLoading, showNotify } = useApp();

    useEffect(() => {
        console.log("user", user)
        if (user) {
            form.setFieldsValue(user.work_space);
        } else {
            form.setFieldsValue({});
        }

    }, [open, user])

    const onFinish = async () => {
        const data = { ...form.getFieldsValue(), user_id: user.id };
        showLoading(true);
        await service.updateUserRole(data);
        showNotify("Đã cập nhật quyền")
        showLoading(false)
        onClose();
        onSaved()


    };
    return (

        <>

            <Modal open={open} title="Cập nhật quyền người dùng" onClose={onClose} onCancel={onClose} onOk={e => form.submit()} >

                <Form layout="vertical" form={form} initialValues={{}} onFinish={() => onFinish()} >
                    <UserFields></UserFields>

                </Form>

            </Modal>
        </>
    )



}


const UserFields = () => {
    return (
        <>
            <Form.Item

                label="Vai trò"
                name="role"
                rules={[

                    {
                        required: true,


                    },
                ]}
            >
                <Select options={[
                    { label: "Quản trị viên", value: "admin" },
                    { label: "Nhân viên", value: "staff" },
                ]} ></Select>

            </Form.Item>





            <Form.Item
                label="Phân quyền"
                name="permissions"
                rules={[
                    {
                        required: true,
                        message: "Bạn phải chọn 1 quyền"
                    },


                ]}
            >
                <Select options={permissions} mode='multiple'></Select>
            </Form.Item>
        </>
    )
}
export default UserList;